import React from 'react'
import { Button } from 'antd'

export default class Item extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showDelete: false
        }
    }

    delete = () => {
        const { user, deleteItem } = this.props
        this.setState({ showDelete: false })
        deleteItem(user.tempId)
    }

    checkError = (errorArray, errorString) => {
        return errorArray.find((error) => error.includes(errorString))
    }

    errors = {
        phone: this.props.user.typeErr &&
                    this.checkError(this.props.user.typeErr, 'PHONE'),
        identity: this.props.user.typeErr &&
                    this.checkError(this.props.user.typeErr, 'IDENTITY'),
        email: this.props.user.typeErr &&
                    this.checkError(this.props.user.typeErr, 'EMAIL'),

        crm_phone: this.props.user.crmErr &&
                    this.checkError(this.props.user.crmErr, 'PHONE'),
        crm_identity: this.props.user.crmErr &&
                    this.checkError(this.props.user.crmErr, 'IDENTITY'),
        crm_email: this.props.user.crmErr &&
                    this.checkError(this.props.user.crmErr, 'EMAIL'),
    }

    errorColor = (field) => {
        if (this.errors[field] && this.errors[`crm_${field}`]) {
            return 'red'
        } else if (this.errors[field]) {
            return 'orange'
        } else if (this.errors[`crm_${field}`]) {
            return 'purple'
        }
    }

    render() {
        const { showDelete } = this.state
        const { user, edit } = this.props
        return (
            <div style={{ ...style.line }}>
                <div style={{ ...style.cell }}>
                    {`שם פרטי: ${user.first_name}`}
                </div>
                <div style={{ ...style.cell }}>
                    {`שם משפחה: ${user.last_name}`}
                </div>
                <div
                    style={{
                        ...style.cell,
                        color: this.errorColor('phone')
                    }}
                >
                    {`טלפון: ${user.phone}`}
                </div>
                <div
                    style={{
                        ...style.cell,
                        color: this.errorColor('email')
                    }}
                >
                    {`אימייל: ${user.email}`}
                </div>
                <div
                    style={{
                        ...style.cell,
                        color: this.errorColor('identity')
                    }}
                >
                    {`מ. זהות: ${user.identity}`}
                </div>
                <div style={{ ...style.cell }}>
                    {`ת. לידה: ${user.birthday}`}
                </div>
                <div style={{ ...style.cell, width: '7%' }}>
                    {`קופ״ח: ${user.hmo_id}`}
                </div>
                <div style={{ ...style.cell, width: '7%' }}>
                    {`שב״ן: ${user.hmo_plan_id}`}
                </div>
                {!showDelete &&
                    <>
                        <Button onClick={() => edit(user.tempId)}>{"עריכה"}</Button>
                        <Button onClick={() => this.setState({ showDelete: true })}>{"מחיקה"}</Button>
                    </>}
                {showDelete &&
                    <div>
                        <h6>{"למחוק?"}</h6>
                        <Button onClick={() => this.delete()}>{"אישור"}</Button>
                        <Button onClick={() => this.setState({ showDelete: false })}>{"ביטול"}</Button>
                    </div>}
            </div>
        ) 
    }
}


const style = {
    line: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        height: '50px',
        marginBottom: '28px'
    },
    cell: { width: '11%' }
}